/* Redesign · Step 3 — Immersive product view controller.
   Opens a full-screen layer from the homepage grid.
   Swipe/Arrow Left-Right = photos · Up-Down = previous/next product · Esc/× = close.
   Reads product data from the JSON in #lw-grid-data. No cart/checkout code here. */
(function () {
  var root = document.getElementById('lwImmersive');
  var dataEl = document.getElementById('lw-grid-data');
  if (!root || !dataEl) return;

  var products = [];
  try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!products.length) return;

  var track    = root.querySelector('.lw-immersive__track');
  var dotsEl   = root.querySelector('.lw-immersive__dots');
  var titleEl  = root.querySelector('.lw-immersive__title');
  var priceEl  = root.querySelector('.lw-immersive__price');
  var stage    = root.querySelector('.lw-immersive__stage');
  var drawer       = root.querySelector('.js-lwDrawer');
  var descEl       = root.querySelector('.lw-immersive__desc');
  var disclaimerEl = root.querySelector('.lw-immersive__disclaimer');
  var addBtn       = root.querySelector('.js-lwAddBtn');
  var checkoutLink = root.querySelector('.js-lwCheckout');
  var notifyUrl    = root.getAttribute('data-notify-url') || '';

  var pIndex = 0; // current product
  var iIndex = 0; // current image
  var isOpen = false;

  function renderProduct() {
    var p = products[pIndex];
    iIndex = 0;

    track.innerHTML = '';
    p.images.forEach(function (url, i) {
      var slide = document.createElement('div');
      slide.className = 'lw-immersive__slide';
      var img = document.createElement('img');
      img.className = 'lw-immersive__img';
      img.src = url;
      img.alt = p.title;
      img.draggable = false;
      img.loading = i === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);
    });

    dotsEl.innerHTML = '';
    if (p.images.length > 1) {
      p.images.forEach(function () {
        var d = document.createElement('span');
        d.className = 'lw-immersive__dot';
        dotsEl.appendChild(d);
      });
    }

    titleEl.textContent = p.title;
    priceEl.textContent = p.price;

    descEl.innerHTML = p.description || '';
    disclaimerEl.hidden = !p.entheogen;
    collapseDrawer();
    setupBuyButton(p);

    showImage(0, false);
  }

  /* ---- Drawer (description) ---- */
  function expandDrawer() {
    drawer.classList.add('is-expanded');
    var g = drawer.querySelector('.js-lwDrawerToggle');
    if (g) g.setAttribute('aria-expanded', 'true');
  }
  function collapseDrawer() {
    drawer.classList.remove('is-expanded');
    var g = drawer.querySelector('.js-lwDrawerToggle');
    if (g) g.setAttribute('aria-expanded', 'false');
  }
  function toggleDrawer() {
    drawer.classList.contains('is-expanded') ? collapseDrawer() : expandDrawer();
  }

  /* ---- Buy bar (native Shopify cart) ---- */
  function firstSellableVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) return vs[i]; }
    return vs[0] || null;
  }
  function applyBuyState(p, v) {
    addBtn.classList.remove('is-added', 'is-notify');
    if (!p.available || !v || !v.available) {
      addBtn.classList.add('is-soldout');
      addBtn.removeAttribute('data-variant');
      if (notifyUrl) {
        addBtn.textContent = 'Sold out — notify me';
        addBtn.disabled = false;
        addBtn.classList.add('is-notify');
      } else {
        addBtn.textContent = 'Sold out';
        addBtn.disabled = true;
      }
    } else {
      addBtn.textContent = 'Add to bag';
      addBtn.disabled = false;
      addBtn.classList.remove('is-soldout');
      addBtn.setAttribute('data-variant', v.id);
    }
  }
  function setupBuyButton(p) {
    var variantsEl = root.querySelector('.lw-immersive__variants');
    variantsEl.innerHTML = '';
    var vs = p.variants || [];

    if (vs.length > 1) {
      variantsEl.hidden = false;
      vs.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lw-immersive__variant';
        b.textContent = v.title;
        b.disabled = !v.available;
        b.setAttribute('data-variant', v.id);
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          if (b.disabled) return;
          Array.prototype.forEach.call(variantsEl.children, function (c) { c.classList.remove('is-active'); });
          b.classList.add('is-active');
          applyBuyState(p, v);
        });
        variantsEl.appendChild(b);
      });
      var def = firstSellableVariant(p);
      var defBtn = def ? variantsEl.querySelector('[data-variant="' + def.id + '"]') : null;
      if (defBtn) defBtn.classList.add('is-active');
      applyBuyState(p, def);
    } else {
      variantsEl.hidden = true;
      applyBuyState(p, firstSellableVariant(p));
    }
  }
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && c.item_count > 0) {
          checkoutLink.hidden = false;
          checkoutLink.textContent = 'Checkout (' + c.item_count + ')';
        } else {
          checkoutLink.hidden = true;
        }
      })
      .catch(function () {});
  }

  function showImage(i, animate) {
    var imgs = products[pIndex].images;
    if (i < 0) i = 0;
    if (i > imgs.length - 1) i = imgs.length - 1;
    iIndex = i;
    track.style.transition = animate === false ? 'none' : '';
    track.style.transform = 'translateX(' + (-i * 100) + '%)';
    var dots = dotsEl.children;
    for (var k = 0; k < dots.length; k++) {
      dots[k].classList.toggle('is-active', k === i);
    }
  }

  function nextImage() { showImage(iIndex + 1); }
  function prevImage() { showImage(iIndex - 1); }

  function goProduct(dir) {
    var n = pIndex + dir;
    if (n < 0 || n > products.length - 1) return;
    pIndex = n;
    root.classList.remove('is-switch-up', 'is-switch-down');
    // restart the slide-in animation
    void root.offsetWidth;
    root.classList.add(dir > 0 ? 'is-switch-up' : 'is-switch-down');
    renderProduct();
  }
  function nextProduct() { goProduct(1); }
  function prevProduct() { goProduct(-1); }

  function open(index) {
    pIndex = Math.max(0, Math.min(index, products.length - 1));
    renderProduct();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lw-immersive-open');
    isOpen = true;
    updateCartCount();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lw-immersive-open');
    isOpen = false;
  }

  // Open from a grid tile (intercept the normal link)
  document.addEventListener('click', function (e) {
    var item = e.target.closest('.lw-grid__item');
    if (!item) return;
    e.preventDefault();
    var idx = parseInt(item.getAttribute('data-product-index'), 10);
    open(isNaN(idx) ? 0 : idx);
  });

  // Close + on-screen controls
  var closeBtn = root.querySelector('.js-lwImmersiveClose');
  if (closeBtn) closeBtn.addEventListener('click', close);
  Array.prototype.forEach.call(root.querySelectorAll('[data-lw-action]'), function (btn) {
    btn.addEventListener('click', function () {
      var a = btn.getAttribute('data-lw-action');
      if (a === 'prev-photo') prevImage();
      else if (a === 'next-photo') nextImage();
      else if (a === 'prev-product') prevProduct();
      else if (a === 'next-product') nextProduct();
    });
  });

  // Keyboard (desktop)
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { close(); }
    else if (e.key === 'ArrowLeft') { prevImage(); }
    else if (e.key === 'ArrowRight') { nextImage(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); prevProduct(); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); nextProduct(); }
  });

  // Touch gestures: horizontal = photos, vertical = products
  var sx = 0, sy = 0, tracking = false;
  stage.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
  }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (!tracking) return;
    tracking = false;
    var t = e.changedTouches[0];
    var dx = t.clientX - sx, dy = t.clientY - sy;
    var ax = Math.abs(dx), ay = Math.abs(dy);
    var TH = 45;
    if (Math.max(ax, ay) < TH) return;
    if (ax > ay) { dx < 0 ? nextImage() : prevImage(); }
    else { dy < 0 ? nextProduct() : prevProduct(); }
  }, { passive: true });

  // Trackpad two-finger swipe / mouse-wheel (desktop):
  // horizontal = photos, vertical = products. One gesture = one step.
  var wheelLock = false, accX = 0, accY = 0, wheelIdle = null;
  function wheelFire(fn) {
    fn();
    wheelLock = true; accX = 0; accY = 0;
    setTimeout(function () { wheelLock = false; }, 500);
  }
  stage.addEventListener('wheel', function (e) {
    if (!isOpen) return;
    e.preventDefault();
    if (wheelLock) return;
    accX += e.deltaX;
    accY += e.deltaY;
    clearTimeout(wheelIdle);
    wheelIdle = setTimeout(function () { accX = 0; accY = 0; }, 200);
    var TH = 60;
    if (Math.abs(accX) > Math.abs(accY)) {
      if (accX > TH) wheelFire(nextImage);
      else if (accX < -TH) wheelFire(prevImage);
    } else {
      if (accY > TH) wheelFire(nextProduct);
      else if (accY < -TH) wheelFire(prevProduct);
    }
  }, { passive: false });

  // Drawer toggle (click / keyboard) + swipe on the grip
  Array.prototype.forEach.call(root.querySelectorAll('.js-lwDrawerToggle'), function (el) {
    el.addEventListener('click', toggleDrawer);
    el.addEventListener('keydown', function (e) {
      if (e.target !== el) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleDrawer(); }
    });
  });
  var grip = root.querySelector('.lw-immersive__grip');
  if (grip) {
    var gsy = 0, gtracking = false;
    grip.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      gsy = e.touches[0].clientY; gtracking = true;
    }, { passive: true });
    grip.addEventListener('touchend', function (e) {
      if (!gtracking) return;
      gtracking = false;
      var dy = e.changedTouches[0].clientY - gsy;
      if (Math.abs(dy) < 28) return;
      dy < 0 ? expandDrawer() : collapseDrawer();
    }, { passive: true });
  }

  // Add to bag — native Shopify AJAX cart (does not touch checkout)
  addBtn.addEventListener('click', function () {
    if (addBtn.classList.contains('is-notify')) {
      if (notifyUrl) window.open(notifyUrl, '_blank', 'noopener');
      return;
    }
    var vid = addBtn.getAttribute('data-variant');
    if (!vid || addBtn.disabled) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        addBtn.textContent = 'Added ✓';
        addBtn.classList.add('is-added');
        updateCartCount();
        setTimeout(function () {
          addBtn.classList.remove('is-added');
          addBtn.textContent = 'Add to bag';
          addBtn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        addBtn.textContent = 'Try again';
        addBtn.disabled = false;
      });
  });

  // Expose for later steps (drawer/buy bar)
  window.lwImmersive = {
    open: open,
    close: close,
    current: function () { return products[pIndex]; }
  };
})();
